<petitum-form *ngIf="petitum" [petitum]="petitum"
                  (onValidForm)="onValidPetitum($event)" 
                  [submitPending]="submitPending"
                  (onUpdatePetitum) = "retrievePetitum($event)"
                  [suggested] = "entities && entities.length > 0"
></petitum-form>

<div class="row wizard-buttons" style="border: none!important;">
  <!-- <p class="col-sm-2 col-xs-6">
    <button *ngIf="!submitPending" type="button" class="btn btn-outline-secondary btn-block" (click)="onReset()">Reset</button>
  </p> -->
  <p class="col-sm-3 col-xs-6" >
    <button  type="button" *ngIf="!submitPending" class="btn btn-outline-secondary btn-block" (click)="discard()">Annulla</button>
  </p>
  <p class="col-sm-3 col-xs-6 col-sm-offset-6" *ngIf="!submitPending; else modifica">
    <button type='button' class='btn btn-primary btn-block' [disabled]="!isContinueEnabled" (click)="onContinue()">
      Salva
    </button>
  </p>
  <ng-template #modifica>
    <p class="col-sm-3 col-xs-6 col-sm-offset-6">
      <button type='button' class='btn btn-primary btn-block' (click)="submitPending = false">
        Modifica dati
      </button>
    </p>
  </ng-template>
</div>

